/**
 * Created with IntelliJ IDEA.
 * User: elanh
 * Date: 4/10/13
 * Time: 4:19 PM
 */

/*
 The ContentCannedModel - the mother of all models
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var LE = require("app");

    var cannedMessageConfig = require("content-config/cannedMessageConfig.json");
    var cannedMessagesMacro = require("assets/config/entities/predefined-content.json").macro;

    var ContentCannedUtilities;
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {
        ContentCannedUtilities = {
            macros: function () {
                var macros = [];
                var prefix = cannedMessagesMacro.regex.prefix;
                var suffix = cannedMessagesMacro.regex.suffix;
                Object.keys(cannedMessagesMacro.patterns).forEach(function (key) {
                    macros.push({id: key, value: prefix + key + suffix});
                });
                return macros;
            },

            saveEmptyTooltip: function(){
                return cannedMessageConfig.SaveTooltip.empty;
            },
            saveNoChangesTooltip: function () {
                return cannedMessageConfig.SaveTooltip.noChanges;
            },
            getHeaderTexts: function(isNew,type) {
                var mode = isNew?"new":"edit";
                return cannedMessageConfig.contentHeader[mode][type];
            }
        };
    });

    return ContentCannedUtilities;
});
